define('v3/Common/Bindings/Collapse.Binding',['jquery', 'knockout'], function ($, ko) {
	var allowCollapsing = true;

	function dynamicContentHandler ($element, collapsed) {
		if (!$element.length || collapsed()) {
			return;
		}

		var scrollHeight = $element.prop('scrollHeight');

		if (scrollHeight === $element.prop('clientHeight')) {
			$element.addClass('collapsing');
		}

		$element.css('height', scrollHeight);

		setTimeout(function () {
			var elementHeight = 0;

			// cant use scollHeight because the content could alo been decreased
			$element.children().each(function (index, elm) {
				elementHeight += $(elm).outerHeight(true);
			});

			// heights are the same so transition end event will never start
			if (scrollHeight === elementHeight) {
				$element.removeAttr('style');
				setElement($element);
			} else { $element.css('height', elementHeight); }
		}, 0);
	}

	function setElement ($element) {
		$element.removeClass('collapsing');
		$element.prop('scrollHeight') === $element.prop('clientHeight') ? $element.removeClass('has-scrollbar') : $element.addClass('has-scrollbar');
	}

	ko.bindingHandlers.collapse = {
		init: function (element, valueAccessor) {
			allowCollapsing = false;

			var collapseOptions = valueAccessor();
			var collapsed = collapseOptions.collapsed;
			var dynamicContent = collapseOptions.dynamicContent;
			var $element = $(element);

			// if content changes, you have to calculate your element again
			if (dynamicContent) {
				dynamicContent.subscribe(function () {
					dynamicContentHandler($element, collapsed);
				});
			}

			$element.on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function () {
				if ($element.prop('clientHeight') > 0) {
					$element.removeAttr('style');
				}
				setElement($element);
			});

			collapsed.subscribe(function () {
				allowCollapsing = true;
			});
		},
		update: function (element, valueAccessor) {
			var collapseOptions = valueAccessor();
			var collapsed = ko.unwrap(collapseOptions.collapsed);
			var $element = $(element);

			if ($element.length > 0) {
				if (allowCollapsing) {
					$element.addClass('collapsing');

					$element.css('height', !collapsed ? 0 : $element.prop('scrollHeight'));

					setTimeout(function () {
						$element.css('height', collapsed ? 0 : $element.prop('scrollHeight'));
					}, 0);

					allowCollapsing = false;
				} else if (collapsed) {
					$element.css('height', 0);
				}
			}
		}
	};
});

